import { render } from "./Info.vue?vue&type=template&id=601afa9c&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=601afa9c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-601afa9c"

export default script